import { SelectedTimeSliceModel } from '../../../components/time_slice_tiles/models/selected_time_slice_model';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ICalendarSection, ICalendarBusyTime } from '../../../interfaces/scheduler_interfaces';
import { CalendarTimesModel } from '../models/calendar_times_model';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../../../swap/models/course_section_swap_model';
import { CalendarScheduledSectionServant } from '../servants/calendar_scheduled_section_servant';
import { IWaitlistStatusDatasource } from '../../course_scheduler/datasources/waitlist_status_datasource';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';

export class CalendarSwapTimesQuery implements IQuery {
  private _result: {
    times: Array<ICalendarBusyTime | ICalendarSection>;
    loadedTimes: boolean;
  };

  constructor(
    private QueryMediator: IQueryMediator,
    private ngCalendarTimesModel: CalendarTimesModel,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngCalendarScheduledSectionServant: CalendarScheduledSectionServant,
    private ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
    private ngSelectedTimeSliceModel: SelectedTimeSliceModel,
    private ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource
  ) {
    this._result = {
      times: [],
      loadedTimes: false
    };
    QueryMediator.registerQuery(
      this,
      ngWaitlistStatusDatasource,
      ngSectionAvailabilityDatasource,
      ngCalendarTimesModel,
      ngSelectedTimeSliceModel,
      ngSectionsDatasource,
      ngCourseSectionSwapModel
    );
  }

  run() {
    // KEEP FOR FUTURE CALENDAR SWAP LOGIC
    // const sections = _4.filter(this.ngSectionsDatasource.read(),(section: ISection) => section.status === 'SWAP_FROM');
    // const builtSections = this.ngCalendarScheduledSectionServant.buildCalendarSections(sections);
    // console.log(builtSections);
    const newCalendarSnapshot = this.ngCalendarTimesModel.read();
    const times = _4.compact(_4.concat(newCalendarSnapshot.busy_times, newCalendarSnapshot.section_times));
    this._result = {
      times,
      loadedTimes: newCalendarSnapshot.loaded_times
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCalendarSwapTimesQuery', CalendarSwapTimesQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/queries/calendar_swap_times_query.ts